
import React from "react";

export default function SearchPaginator(props) {

    if (props.results) {

        let currentLinkUrl = props.results.links.find(link => link.active).url;

        const loadSearchResultPage = (url) => {
            props.loadSearchResultPage(url)
        }

        const setPageSize = (event) => {
            let newUrl = currentLinkUrl
                .replace(/pageSize=(\d+)/, 'pageSize='+event.target.value)
                .replace(/page=(\d+)/, 'page=1')
            props.loadSearchResultPage(newUrl)
        }

        let idx = 1
        let paginatorLinks = props.results.links.map((link) =>
            (
                <li className={"page-item" + (link.active ? " active" : "") } key={idx++} >
                    {
                        (link.url && !link.active) ?
                            (<a
                                className="page-link "
                                onClick={() => { loadSearchResultPage(link.url) }}
                                style={{cursor: 'pointer', wordBreak: 'normal'}}
                                dangerouslySetInnerHTML={{__html: link.label}}
                            />) :
                            (<span
                                className="page-link"
                                dangerouslySetInnerHTML={{__html: link.label}}
                            />)
                    }
                </li>
            )
        )

        let paginationOptions = [15, 25, 50, 100, 250, "all"];
        let defaultPageSize = currentLinkUrl.match(/pageSize=(\d+)/)[1]

        return (
            <div className="row">
                <nav>
                    <ul className="pagination">
                        {paginatorLinks}
                    </ul>
                </nav>

                <div className="col-auto">
                    <select name="pageSize" id="pageSize" className="form-control" defaultValue={defaultPageSize} onChange={setPageSize}>
                        {
                            paginationOptions.map((option) => (
                                <option value={option} key={option} >
                                { option === "all" ? "-- All Results --" : option + ' per page' }
                                </option>
                                )
                            )
                        }
                    </select>
                </div>

                <div className="col-auto ms-auto pt-2 pe-0">
                    { props.results.total } Records
                </div>
            </div>
        )
    }
}
